"use strict";

import { TouchableNativeFeedback as RNTouchableNativeFeedback } from 'react-native';

/**
 * @deprecated TouchableNativeFeedback will be removed in the future version of Gesture Handler. Use Pressable instead.
 */
const TouchableNativeFeedback = RNTouchableNativeFeedback;
export default TouchableNativeFeedback;
//# sourceMappingURL=TouchableNativeFeedback.js.map